import { useState } from "react";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { PropagateLoader } from "react-spinners";
import Modal from "../molecules/Modal";
import useModal from "../../hooks/useModal";
import { GET_FILE } from "../../api/apiFiles";

const JsonFileInput = ({ name, label, values, setFieldValue, ...res }) => {
  const { id } = useParams();
  const { open, isOpen, close } = useModal();
  const [loadingView, setLoadingView] = useState(false);
  const [uploadingPreview, setUploadingPreview] = useState(false);
  const [documento, setDocumento] = useState();
  const current = values?.[name];

  const onPick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    await setFieldValue(name, { _file: file }, false);

    const isJson =
      file?.type === "application/json" ||
      file?.name?.toLowerCase().endsWith(".json");

    if (isJson) {
      setUploadingPreview(true);
      try {
        const text = await file.text();
        const parsed = JSON.parse(text);
        await setFieldValue(name, { _file: file, _previewParsed: parsed }, false);
      } catch {
      } finally {
        setUploadingPreview(false);
      }
    }
  };

  const hasUploadedJson =
    current &&
    typeof current === "object" &&
    Array.isArray(current.s3Keys) &&
    current.s3Keys.length > 0;

  const hasPendingFile = current && typeof current === "object" && current._file instanceof File;

  const handleOpenDocument = async(s3Key) => {
    try {
      setLoadingView(true);
      open();
      const response = await GET_FILE(id, {s3Key});
      setDocumento(response);
    } catch (error) {
      console.error(error);
      toast.error("Error al obtener el archivo");
    } finally {
      setLoadingView(false);
    }
  };

  return (
    <div>
      <label className="block text-sm font-medium mb-1">{label}</label>
      <input
        type="file"
        accept=".json,application/json,.pdf,application/pdf"
        onChange={onPick}
        className="block w-full text-sm"
        {...res}
      />

      {uploadingPreview && <p className="text-sm text-gray-500 mt-1">Leyendo JSON…</p>}

      {hasUploadedJson && (
        <button type="button" onClick={()=>handleOpenDocument(current.s3Keys?.[0])}  className="mt-2 text-xs border rounded p-1 bg-purple-600 text-white font-bold">
          <p><b>Archivo:</b> {current.filenames?.[0]}</p>
          {current.parsed && (
            <>
              <p className="mt-2"><b>Preview JSON:</b></p>
              <pre className="max-h-48 overflow-auto">{JSON.stringify(current.parsed, null, 2)}</pre>
            </>
          )}
        </button>
      )}

      {hasPendingFile && (
        <div className="mt-2 text-xs border rounded p-2 bg-gray-50">
          <p><b>Pendiente por subir:</b> {current._file?.name}</p>
          {current._previewParsed && (
            <>
              <p className="mt-2"><b>Preview JSON:</b></p>
              <pre className="max-h-48 overflow-auto">
                {JSON.stringify(current._previewParsed, null, 2)}
              </pre>
            </>
          )}
          <p className="mt-1 text-gray-500">Se subirá cuando presiones “Guardar”.</p>
        </div>
      )}
      {isOpen &&
        <Modal title="Previsualización del Documento" onClose={close}>
          <div className="w-full h-[80vh] flex justify-center items-center">
          {loadingView ?
            <PropagateLoader color="red" />
          :
            <iframe src={documento} className="h-full w-full" title="Documento Previsualizado" />
          }
          </div>
        </Modal>
      }
    </div>
  );
};

export default JsonFileInput;